var checkedStatesToBool = value => {
  switch (value) {
    case true:
    case 'checked':
      return true;
    case false:
    case 'unchecked':
    case 'indeterminated':
    default:
      return false;
  }
};
var checkboxStates = value => {
  switch (value) {
    case 'indeterminated':
      return 'indeterminated';
    case 'checked':
    case true:
      return 'checked';
    case 'unchecked':
    case false:
    default:
      return 'unchecked';
  }
};
var checkboxStringProp = {
  false: 'unchecked',
  true: 'checked',
  indeterminated: 'indeterminated',
  checked: 'checked',
  unchecked: 'unchecked'
};
export { checkboxStates, checkedStatesToBool, checkboxStringProp };